import styled from 'styled-components';
import { Box } from '@mui/material';

export const DetailBoxWrapper = styled(Box)`

border: 1px solid #1B4A83;
border-radius: 0px 0px 5px 5px;


.d-flex{
        flex-wrap: wrap;
        border-bottom: 1px solid rgba(224, 224, 224, 1);
    padding: 10px;
    .content{
        width: 21%;
        text-align: left;
        padding: 0px 5px 0px 20px;
       
        h5{
            height: 10px;
            font-size:16px;
            color:#1B4A83;
            b{
                font-weight: 400;
                font-size:13px;
            }
        }               

        .other-detail-subheading{
            height: 10px;
            font-size:16px;
            color:#1B4A83;
            b{
                font-weight: 400;
                font-size:13px;
            }
        }
               
        .icon
{
    padding: 0px;
     color: #1B4A83;
}

.smallTxtField{
    
            font-size: 14px;
            .MuiInputBase-input {
              background-color: #fff;
              height: 0.4375em;              
              border-radius: 5px;
              font-family: "Noto Sans", sans-serif;
            }
}

    }
    
}
d-flex{
        flex-wrap: wrap;
        border-bottom: 1px solid rgba(224, 224, 224, 1);
    padding: 10px;
    .content{
        width: 21%;
        text-align: left;
        padding: 0px 5px 0px 20px;
       
        h5{
            height: 10px;
            font-size:16px;
            color:#1B4A83;
            b{
                font-weight: 400;
                font-size:13px;
            }
        }               

        .other-detail-subheading{
            height: 10px;
            font-size:16px;
            color:#1B4A83;
            b{
                font-weight: 400;
                font-size:13px;
            }
        }
               
        .icon
{
    padding: 0px;
     color: #1B4A83;
}

.smallTxtField{
    
            font-size: 14px;
            .MuiInputBase-input {
              background-color: #fff;
              height: 0.4375em;              
              border-radius: 5px;
              font-family: "Noto Sans", sans-serif;
            }
}

    }
    
}
.ul-content{        
        text-align: left;
        padding: 0px 5px 0px 20px;

        .componentList{
            font-size:16px;
            
            b{
                font-weight: 400;
                font-size:13px;
            }       
        }
    }

.border{
   borderBottom:1px solid rgba(224, 224, 224, 1);
}

`
;
